import { KeyboardEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPen, faTrash, faPlus, faAngleDoubleRight, faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";

import { Input } from "../../components/Input";
import { Topo } from "../../components/Topo";

import "./style.css";

import { api } from "../../services/api";
import { useCache } from "../../hooks/useCache";

import { Load } from "../../components/Load";
import { IClientes, IListRequest } from "../../global/types";
import { maskCpfCnpj, maskPhone } from "../../utils/masks";
import { checkToken } from "../../utils/checkToken";

const limitPage = 25;

export function Clientes() {
  const navigate = useNavigate();

  const { refreshToken, usuario, cacheTokens, token, setAlert } = useCache();
  const cacheError = { refreshToken, usuario, cacheTokens };

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [pesquisa, setPesquisa] = useState("");
  const [loading, setLoading] = useState(false);

  const [listClientes, setListClientes] = useState<IClientes[]>([]);

  const loadClientes = async (canPesquisa = false) => {
    if (!token)
      return;

    setLoading(true);

    const rsCheckToken = await checkToken(cacheError, token);
    if (rsCheckToken.redirectLogin)
      navigate("/login");

    let dataRequest: IListRequest = {
      cursor: (limitPage * page) - limitPage,
      limit: limitPage
    }

    if (canPesquisa)
      dataRequest = { ...dataRequest, pesquisa };

    await api.post("clientes/findAll", dataRequest)
      .then((response) => {
        if (!response.data)
          return;

        const newMaxPage = Math.ceil(response.data.total / limitPage);

        setMaxPage(newMaxPage < 1 ? 1 : newMaxPage);
        setListClientes(response.data.result);
      })
      .catch(async (err) => {
        if (err.response.status !== 401)
          setAlert(err.response.data.message, "danger");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handlePesquisa = () => {
    setPage(1);
    loadClientes(true);
  }

  const handleKeyPesquisa = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter")
      handlePesquisa();
  }

  const handleDelete = async (id: string) => {
    if (!token)
      return;

    if (!window.confirm("Deseja realmente excluir este cliente?"))
      return;

    setLoading(true);

    const rsCheckToken = await checkToken(cacheError, token);
    if (rsCheckToken.redirectLogin)
      navigate("/login");

    await api.delete('clientes', { data: { id } })
      .then(() => { })
      .catch((err) => {
        if (err.response.status !== 401)
          setAlert(err.response.data.message, "danger");
      })
      .finally(() => {
        loadClientes(true);
      });

  };

  useEffect(() => {
    loadClientes();
  }, [token]);

  useEffect(() => {
    loadClientes(true);
  }, [page]);

  return (
    <Topo page="Clientes" title="Clientes">
      <>
        <div className="divPesquisa">
          <Input
            mask="none"
            value={pesquisa}
            inputMaskChange={setPesquisa}
            placeholder="Pesquisa..."
            onKeyUp={handleKeyPesquisa}
          />
          <button onClick={handlePesquisa}>
            <FontAwesomeIcon icon={faSearch} />
          </button>
          <button className="btn-green" onClick={() => { navigate("/clientes/novo") }}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        <div className="gridContext">
          <div className="headTable">
            <span style={{ width: "200px" }}>Fantasia</span>
            <span style={{ width: "200px" }}>Razão Social</span>
            <span style={{ width: "150px" }}>CNPJ/CPF</span>
            <span style={{ width: "150px", textAlign: "center" }}>Telefone/Celular</span>
            <span style={{ width: "200px", textAlign: "center" }}>Ações</span>
          </div>

          <div className="contentTable">
            {loading && (
              <Load txtLoading="Carregando..." options={{ height: 120, width: 120 }} />
            )}

            {!loading && listClientes.length > 0 && (
              listClientes.map((item) => (
                <div className="rowTable" key={item.id}>
                  <span style={{ width: "200px" }}>{item.fantasia}</span>
                  <span style={{ width: "200px" }}>{item.razao_social}</span>
                  <span style={{ width: "150px" }}>{maskCpfCnpj(`${item.cpf_cnpj}`)}</span>
                  <span style={{ width: "150px", textAlign: "center" }}>{`${maskPhone(`${item.telefone}`)} / ${maskPhone(`${item.celular}`)}`}</span>
                  <span style={{ width: "200px", textAlign: "center" }}>
                    <button className="btn-orange" onClick={() => { navigate(`/clientes/${item.id}`) }}>
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                    <button className="btn-red" onClick={() => handleDelete(item.id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </span>
                </div>
              ))
            )}

          </div>

          <div className="pagination">
            {page !== 1 && (
              <FontAwesomeIcon icon={faAngleDoubleLeft} style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setPage(i => --i)} />
            )}
            <p>
              {page}/{maxPage}
            </p>
            {page !== maxPage && (
              <FontAwesomeIcon icon={faAngleDoubleRight} style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setPage(i => ++i)} />
            )}
          </div>

        </div>

      </>
    </Topo>
  );
}